import React from 'react';
import * as partnerLogos from '../images/partner-logos';

export const PARTNER_LOGOS: Record<string, React.FC<React.SVGProps<SVGSVGElement>>> = {
  estimateOneLogo: partnerLogos.EstimateOneLogo
};
